import angular from 'angular';
import constants from 'app/constants';
import {
  pmDataService,
  pmSharedModelService,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
} from 'app/components/global';
import controller from './document-addendum.controller';
import directive from './document-addendum.directive';


export default angular.module('app.components.advisory.pm.documentAddendum', [
  alerts,
  pmDataService,
  pmSharedModelService,
  confirmDialog,
  constants,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
])
  .directive('pmDocumentAddendum', directive)
  .controller('DocumentAddendumController', controller)
  .name;

console.log('app.components.advisory.pm.documentAddendum created');
